import scrollToElement from '../services/scrollService';

/* eslint-disable */

export default function accordion() {
    'use strict';

    const self = {};
    const items = jQuery('.accordion__item');

    items.find('.js-accordion-headline').on('click', nodeClick);

    function nodeClick(event) {
        const item = jQuery(this).parent();

        if (item.hasClass('is-active')) {
            item.find('.accordion__text').css('display', 'block').slideUp(350)
            item.removeClass('is-active');
        }
        else {
            var activeItems = items.filter('.is-active');
            activeItems.find('.accordion__text').css('display', 'block').slideUp(350);
            activeItems.removeClass('is-active');

            item.find('.accordion__text')
                .slideDown(350, () => {
                    item.addClass('is-active');
                    scrollToElement(event.target);
                });
        }
    }

    return self;
}
